import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import { Provider } from "react-redux";
import store from "./redux/storeRedux";
import { registerSmartTTServiceWorker } from "./pwa/registerServiceWorker";
import { initPwaInstallCapture } from "./pwa/installPrompt";

initPwaInstallCapture();

// Suppress MetaMask/extension errors so they don't crash the app overlay
const isExtensionError = (msg, stack) =>
  (msg && typeof msg === "string" && msg.includes("MetaMask")) ||
  (stack && typeof stack === "string" && stack.includes("chrome-extension://"));
window.onerror = (msg, source, _lineno, _colno, error) => {
  if (isExtensionError(msg, error?.stack)) return true;
};
window.onunhandledrejection = (ev) => {
  const msg = ev.reason?.message || String(ev.reason);
  const stack = ev.reason?.stack;
  if (isExtensionError(msg, stack)) {
    ev.preventDefault();
    return false;
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

/*
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerSmartTTServiceWorker();
